export const API_BASE = process.env.REACT_APP_API_BASE || 'https://nodereport.2ss.in/api';
